module.exports = __webpack_public_path__ + "img/star_heart.8443a4d8.png";